import React from "react";
import styled from "styled-components";

export interface IInputProps {
  name: string;
  label: string;
  value: string;
  type: string;
  onChange: (value: string) => void;
  onKeyPress?: (key) => void;
}

const Label = styled.label`
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
`;

const Div = styled.div`
  box-sizing: border-box;
  margin-bottom: 10px;
`;

const textInput: React.StatelessComponent<IInputProps> = ({
  name,
  label,
  value,
  type,
  onChange,
  onKeyPress
}) => (
  <Div>
    <Label htmlFor={name}>{label}</Label>
    <input
      type={type || "text"}
      style={{
        boxSizing: "border-box",
        fontFamily: "inherit",
        fontSize: "inherit",
        display: "block",
        width: "100%",
        height: "32px",
        margin: "0px",
        paddingLeft: "8px",
        paddingRight: "8px",
        color: "inherit",
        backgroundColor: "rgba(255, 255, 255, 0.25)",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "rgba(0, 0, 0, 0.25)",
        borderRadius: "0px"
      }}
      name={name}
      value={value}
      onFocus={e => e.target.select()}
      onChange={e => onChange(e.target.value)}
      onKeyPress={e => onKeyPress && onKeyPress(e.key)}
    />
  </Div>
);

export default textInput;
